{
  "😀": ["grinning"],
  "😃": ["smiley"],
  "😄": ["smile"],
  "😁": ["grin"],
  "😆": ["laughing", "satisfied"],
  "😅": ["sweat_smile"],
  "🤣": ["rofl"],
  "😂": ["joy"],
  "🙂": ["simple_smile"],
  "😉": ["wink"],
  "😊": ["blush"],
  "😇": ["innocent"],
  "😍": ["heart_eyes"],
  "😘": ["kissing_heart"],
  "😋": ["yum"],
  "😎": ["cool"],
  "😢": ["cry"],
  "😭": ["sob"],
  "😱": ["scream"],
  "😡": ["rage"],
  "❤️": ["heart"],
  "👍": ["+1", "thumbsup"],
  "👎": ["-1", "thumbsdown"],
  "👋": ["wave"],
  "👏": ["clap"],
  "🙏": ["pray"],
  "💪": ["muscle"],
  "🎉": ["tada"],
  "💯": ["100"],
  "💩": ["poop", "shit"]
}
